import { render, staticRenderFns } from "./SetupClinica.vue?vue&type=template&id=227245ec&"
import script from "./SetupClinica.vue?vue&type=script&lang=js&"
export * from "./SetupClinica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports